import types from '../types/header'
import {Map} from 'immutable'

const initialRoot = Map({
  show: true,
  showSearchBar: true,
  tab: '',
  search: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      if (action.payload.pathname.substring(0, 8) === '/catalog')
        return state.merge({
          show: true,
          showSearchBar: true,
          tab: 'catalog',
        })
      switch (action.payload.pathname) {
        case '/':
          return state.merge({
            show: true,
            showSearchBar: true,
            tab: 'community',
          })
        case '/micatalogo':
          return state.merge({
            show: true,
            showSearchBar: true,
            tab: 'yours',
          })
        case '/profile':
          return state.merge({
            show: true,
            showSearchBar: false,
            tab: '',
          })
        case '/ingresar':
        case '/registrarse':
        case '/recuperar':
          return state.merge({
            show: false,
            showSearchBar: false,
            tab: '',
          })
        case '/privacidad':
          return state.merge({
            show: false,
            showSearchBar: false,
            tab: '',
          })
        default:
          return state.merge({
            show: true,
            showSearchBar: false,
            tab: '',
          })
      }
    case types.SET_SEARCH:
      return state.merge({
        search: action.payload.search,
      })
    default:
      return state
  }
}

export default function(state, action) {
  return root(state, action)
}



// WEBPACK FOOTER //
// ./src/sections/header/reducers/header.js